import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetEventList = () => {
    const [searchParams] = useSearchParams()
    const page = searchParams.get("page")
    const eventTypeFlag = searchParams.get("eventTypeFlag") || "1"
    const eventStateFlag = searchParams.get("eventStateFlag") || "1,2"
    const startDateTime = searchParams.get("startDateTime") || ""
    const endDateTime = searchParams.get("endDateTime") || ""

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        fetchRequest("GET", `/event/list?page=${page}&eventTypeFlag=${eventTypeFlag}&eventStateFlag=${eventStateFlag}&startDateTime=${startDateTime}&&endDateTime=${endDateTime}`)
    }, [page, eventTypeFlag, eventStateFlag, eventStateFlag, startDateTime, endDateTime])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "page") setAlert("page 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "eventTypeFlag") setAlert("대회 종류 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "eventStateFlag") setAlert("대회 상태 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "startDateTime") setAlert("시작 범위 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "endDateTime") setAlert("종료 범위 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [fetchResult]
}

export default useGetEventList